import { render, staticRenderFns } from "./RoleMangent.vue?vue&type=template&id=00ded9f6&scoped=true"
import script from "./RoleMangent.vue?vue&type=script&lang=js"
export * from "./RoleMangent.vue?vue&type=script&lang=js"
import style0 from "./RoleMangent.vue?vue&type=style&index=0&id=00ded9f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ded9f6",
  null
  
)

export default component.exports